import moment from "moment-timezone";

export function formatDayOfWeek(dayOfWeek: number) {
	return moment()
		.isoWeekday(dayOfWeek)
		.format("ddd");
}
